import { useEffect, useRef, useState } from 'react';

import { Accordion } from '@klv/utils/accordion';

import Icon from '../icon';
import * as s from './styles/filter-accordion.module.css';
import type { IFilterAccordion } from './types';

const FilterAccordion = ({
  children,
  className = '',
  label = '',
}: IFilterAccordion) => {
  const ref = useRef<HTMLDetailsElement>(null);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (ref.current) {
      new Accordion(ref.current);
      
      // Set initial state
      setIsOpen(ref.current.open);
      
      // Watch for changes to the open attribute
      const observer = new MutationObserver(() => {
        if (ref.current) {
          setIsOpen(ref.current.open);
        }
      });
      
      observer.observe(ref.current, { attributes: true, attributeFilter: ['open'] });
      
      return () => {
        observer.disconnect();
      };
    }
  }, [ref]);
  
  const detailsAriaLabel = label ? `${label} filter options` : 'Filter options';
  
  return (
    <div className={className}>
      <details open ref={ref} aria-label={detailsAriaLabel}>
        <summary 
          className={s.headerContainer}
          aria-expanded={isOpen}
        >
          {label}
          <div className={s.chevron} aria-hidden>
            <Icon iconName='ChevronNorth' size={2} fillColor='currentColor' />
          </div>
        </summary>
        <div className={`${s.content} content`}>
          {children}
        </div>
      </details>
    </div>
  );
};

export default FilterAccordion;
